// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/inventory_ledger.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InventoryLedgerItem, ItemType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.InventoryLedgerRequest
 */
export class InventoryLedgerRequest extends Message<InventoryLedgerRequest> {
  /**
   * Filter by batch ID to get the inventory ledger for a specific batch
   *
   * @generated from field: string batch_id = 1;
   */
  batchId = "";

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<InventoryLedgerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryLedgerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryLedgerRequest {
    return new InventoryLedgerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryLedgerRequest {
    return new InventoryLedgerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryLedgerRequest {
    return new InventoryLedgerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryLedgerRequest | PlainMessage<InventoryLedgerRequest> | undefined, b: InventoryLedgerRequest | PlainMessage<InventoryLedgerRequest> | undefined): boolean {
    return proto3.util.equals(InventoryLedgerRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryLedgerResponse
 */
export class InventoryLedgerResponse extends Message<InventoryLedgerResponse> {
  /**
   * List of inventory ledger items for the specified batch
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryLedgerItem inventory_ledger_items = 1;
   */
  inventoryLedgerItems: InventoryLedgerItem[] = [];

  /**
   * Total number of inventory ledger items for the specified batch
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<InventoryLedgerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryLedgerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_ledger_items", kind: "message", T: InventoryLedgerItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryLedgerResponse {
    return new InventoryLedgerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryLedgerResponse {
    return new InventoryLedgerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryLedgerResponse {
    return new InventoryLedgerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryLedgerResponse | PlainMessage<InventoryLedgerResponse> | undefined, b: InventoryLedgerResponse | PlainMessage<InventoryLedgerResponse> | undefined): boolean {
    return proto3.util.equals(InventoryLedgerResponse, a, b);
  }
}

